import React from 'react';
import PropTypes, { object } from 'prop-types';
import cn from 'classnames';

import { Text } from 'components/common/Elements/Elements';

import { colorsNew } from 'components/common/charts/helpers/config';

import classes from './LegendStatus.module.scss';

const LegendStatus = ({ legendData, chartColor, legendBigMargin }) => {
  return (
    <ul className={cn(classes.list, legendBigMargin && classes.list_bigMargin)}>
      {legendData.map((item, index) => (
        <li className={classes.item} key={item.name}>
          <div className={classes.title}>
            <div
              className={classes.square}
              style={{
                backgroundColor: chartColor
                  ? chartColor[item.name]
                    ? chartColor[item.name]
                    : colorsNew[index]
                  : colorsNew[index]
              }}
            />
            <Text className={classes.name}>{`${item.name}:`}</Text>
          </div>
          <Text
            className={cn(
              classes.percent,
              legendBigMargin && classes.percent_bigMargin
            )}
            weight="b"
          >{`${item.percent}%`}</Text>
        </li>
      ))}
    </ul>
  );
};

LegendStatus.propTypes = {
  legendData: PropTypes.arrayOf(object),
  chartColor: PropTypes.object,
  legendBigMargin: PropTypes.bool
};

export default LegendStatus;
